// extracted by mini-css-extract-plugin
module.exports = {"confirmModal":"style__confirmModal__6xgO5","buttons":"style__buttons__sGbXl"};